import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { ContainerTypeCrudService } from 'src/app/shared/services/container-type-crud.service';
import { ContainerType } from 'src/app/shared/interfaces/container-type';
import { ContentType } from 'src/app/shared/interfaces/content-type';
import { PackagingType } from 'src/app/shared/interfaces/packaging-type';
import { ContentTypeCrudService } from 'src/app/shared/services/content-type-crud.service';
import { PackagingTypeCrudService } from 'src/app/shared/services/packaging-type-crud.service';

@Component({
  selector: 'app-container-types',
  templateUrl: './container-types.component.html',
  styleUrls: ['./container-types.component.scss']
})
export class ContainerTypesComponent implements OnInit {

  containerTypes: ContainerType[];
  containerType: ContainerType;
  selectedContainerTypes: ContainerType[] = [];

  containerTypeDialog: boolean = false;

  submitted: boolean = false;

  contentTypes: ContentType[] = [];
  packagingTypes: PackagingType[] = [];

  minActivityValues: number[] = [0, 1000];
  maxActivityValues: number[] = [0, 1000];

  contentTypeMap = new Map<string, ContentType>();
  packagingTypeMap = new Map<string, PackagingType>();

  dialogSelectContentKey : string = "";
  dialogSelectPackagingKey : string = "";

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  constructor(
   // private api: APIService,
    private containerTypeService : ContainerTypeCrudService,
    private contentTypeService : ContentTypeCrudService,
    private packagingTypeService : PackagingTypeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Container types'}
    ];

    this.containerTypes = [];
    this.containerType = { } as ContainerType ;
    //this.getAllRecords();
  }

  ngOnInit(): void {
    
    this.dataState();
    let s = this.containerTypeService.GetContainerTypesList(); 
    s.snapshotChanges().subscribe(data => {
      this.containerTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.containerTypes.push(jsonItem as ContainerType);
        }
      })
    });

    // let u = this.unitService.GetUnitsList(); 
    // u.snapshotChanges().subscribe(data => {
    //   this.units = [];
    //   data.forEach(item => {
    //     let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
    //     if (jsonItem) {
    //       if (jsonItem) {
    //         jsonItem['$key'] = item.key;
    //       }
    //       this.units.push(jsonItem as unknown as Unit);
    //     }
    //   })
    // });

    let ct = this.contentTypeService.GetContentTypesList(); 
    ct.snapshotChanges().subscribe(data => {
      this.contentTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.contentTypes.push(jsonItem as unknown as ContentType);
          const content = jsonItem as unknown as ContentType;
          this.contentTypeMap.set( content.$key , content );
        }
      })
    });

    let pt = this.packagingTypeService.GetPackagingTypesList(); 
    pt.snapshotChanges().subscribe(data => {
      this.packagingTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.packagingTypes.push(jsonItem as unknown as PackagingType);
          const packaging = jsonItem as unknown as PackagingType;
          this.packagingTypeMap.set( packaging.$key , packaging );
        }
      })
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'elements', header: 'Elements' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;

    // Exports
    this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
  }

  dataState() {     
    this.containerTypeService.GetContainerTypesList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.ContainerTypes);
            doc.save('content-types.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.containerTypes);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "content-types");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    //this.exportService.exportToCsv(this.containerTypes, 'ContainerTypes', ['companyId', 'companyName', '$key', 'actions']);
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedContainerTypes, 'content-types', exportCols);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.containerType = {} as ContainerType;
    this.submitted = false;
    this.containerTypeDialog = true;
    this.dialogSelectContentKey = "";
    this.dialogSelectPackagingKey = "";
  }

  deleteSelectedContainerTypes() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected Packaging Types?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.containerTypes = this.containerTypes.filter(val => !this.selectedContainerTypes.includes(val));
          this.containerTypes.forEach( pallet => {
            this.containerTypeService.DeleteContainerType(pallet.$key);
          } );
          
          this.selectedContainerTypes = [];
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging types deleted', life: 3000});
      }
  });
  }

  editContainerType(containerType: ContainerType) {
    this.containerType = {...containerType};
    this.containerTypeDialog = true;
  }

  deleteContainerType(containerType: ContainerType) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + containerType.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.containerTypes = this.containerTypes.filter(val => val.$key !== containerType.$key);
            this.containerType = {} as ContainerType;
            this.containerTypeService.DeleteContainerType(containerType.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging Type Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.containerTypeDialog = false;
    this.submitted = false;
  }

  saveContainerType() {
    this.submitted = true;
    if (this.containerType.$key) {
      this.containerTypes[this.findIndexById(this.containerType.$key)] = this.containerType;                
      this.containerTypeService.UpdateContainerType(this.containerType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging Type Updated', life: 3000});
    } else {
      // this.pallet.id = this.createId();
      // this.pallet.image = 'container-placeholder.svg';

      if ( this.packagingTypeMap.has( this.dialogSelectPackagingKey ) ) {
        const packaging = this.packagingTypeMap.get( this.dialogSelectPackagingKey );
        // if (packaging) {
        //   this.containerType.container = packaging ;
        //   if (this.containerType.container.$key) {
        //     delete this.containerType.container.$key
        //     delete this.containerType.container.isEnabled
        //   }
        // }
      }

      if ( this.contentTypeMap.has( this.dialogSelectContentKey ) ) {
        const content = this.contentTypeMap.get( this.dialogSelectContentKey );
        // if (content) {
        //   this.containerType.content = content;
        //   if (this.containerType.content.$key) {
        //     delete this.containerType.content.$key
        //     delete this.containerType.content.isEnabled
        //   }
        // }
      }
      
      
      // dialogSelectContentKey = "";
      //  = "";)

      this.containerTypeService.AddContainerType(this.containerType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Container Type Created', life: 3000});
      this.containerTypes = [...this.containerTypes];
    }
    this.containerTypeDialog = false;
    this.containerType = { } as ContainerType;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.containerTypes.length; i++) {
        if (this.containerTypes[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeContainerType(containerType : ContainerType) {
    const containerTypeTmp = {
      ...containerType
    };
    console.log("SAVE", containerTypeTmp);
    this.containerTypeService.UpdateContainerType(  containerTypeTmp );
  }

}
